<div class="details w-100">
    @if (!!payment.isAccessorial) {
        <div class="mat-caption extra-item-title">Extra item</div>
    }
    <div class="d-flex flex-column-reverse flex-md-row justify-content-between w-100 margin-bottom-sm">
        <div class="info-container flex-grow-1">
            @if (!!payment.isAccessorial) {
                <app-extra-item [paymentCart]="payment" />
            } @else {
                <app-awb-item [paymentCart]="payment" />
            }
            @if (payment.customerReference) {
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center">
                        <div class="mat-caption item-data__title">
                            {{ customerReferenceLabel }}:
                            <span class="text-break item-data__value">{{ payment.customerReference }}</span>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="info-container flex-1">
            @if (newFees && newFees.length) {
                <div class="d-flex flex-column item-data">
                    @for (fee of newFees; let feeIndex = $index; track feeIndex) {
                        <div class="d-flex align-items-center">
                            <app-fee
                                class="w-100"
                                [feeLabel]="fee.feeLabel"
                                [feeValue]="fee.feeValue"
                                [fontClassLabel]="'mat-caption item-data__title'"
                                [fontClassValue]="'mat-caption item-data__value'"
                            />
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
